import React from 'react';
const Partner = ({name}) => {
    return ( 
        <span className="partner">{name}, </span>  
    )
};

export default Partner;
